<div class="container-fluid">
    <div class="table-responsive">
        <table class="table table-striped table-bordered text-center">
            <thead>
                <tr>
                    <th>Items</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Amount</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>API Cost</td>
                    <td>
                        <table class="table table-striped table-bordered text-center">
                            <tbody>
                                <tr *ngIf="!combination_quantity; else displayArray">
                                    <td *ngIf="!show; else hide" (click)="onClick()">{{quantity}}</td>
                                    <ng-template #hide>
                                        <td><input type="text" [(ngModel)]="quantity" /></td>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                        <!-- TO DISPLAY COMBINATION VALUES -->
                        <ng-template #displayArray>
                            <table style="width: 100%;">
                                <tbody>
                                    <tr *ngFor="let Obj of combination_quantity | Object2keyvalue; let index=index">
                                        <td style="padding-top: 20px;">
                                            <ul>
                                                <li *ngIf="!show; else hide" (click)="onClick()">{{ Obj.value }}</li>
                                                <ng-template #hide>
                                        <td><input type="text" [(ngModel)]=" Obj.value" /></td>
                        </ng-template>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
        </ng-template>
        </td>
        <td>
            <table class="table table-striped table-bordered text-center">
                <tbody>
                    <tr *ngIf="!combination_price; else priceArray">
                        <td *ngIf="!showPrice; else hidePrice" (click)="onClick()">{{price}}</td>
                        <ng-template #hidePrice>
                            <td><input type="text" [(ngModel)]="price" /></td>
                        </ng-template>
                    </tr>
                </tbody>
            </table>
            <!-- TO DISPLAY COMBINATION VALUES -->
            <ng-template #priceArray>
                <table style="width: 100%;">
                    <tbody>
                        <tr *ngFor="let Obj of combination_price | Object2keyvalue; let index=index">
                            <td style="padding-top: 20px;">
                                <ul>
                                    <li *ngIf="!show; else hide" (click)="onClick()"> {{ Obj.value }}</li>
                                    <ng-template #hide>
                            <td><input type="text" [(ngModel)]=" Obj.value" /></td>
            </ng-template>
            </ul>
        </td>
        </tr>
        </tbody>
        </table>
        </ng-template>
        </td>
        <td>{{amount}}</td>
        <td><button class="show-more-btn" (click)="showAPICostData()" icon="pi pi-external-link" label="Show">
                Show More
            </button>
        </td>
        </tr>
        <tr>
            <td>RLD </td>
            <td>
                <table class="table table-striped table-bordered text-center">
                    <thead>
                        <tr>
                            <th>Strength</th>
                            <th>Pack Size</th>
                            <th>Total no of packs required</th>
                            <th>Price per pack</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let items of rld_quantity; let i= index">
                            <td>{{items.Strength}}</td>
                            <td>{{items.Pack_size}}</td>
                            <td *ngIf="!totalNumber; else hidetotalNumber" (click)="onClick()">
                                {{items.Total_no_of_packs_required}}</td>
                            <ng-template #hidetotalNumber>
                                <td><input type="text" [(ngModel)]="items.Total_no_of_packs_required" /></td>
                            </ng-template>
                            <td *ngIf="!showPricePer; else hidePricePer" (click)="onClick()">{{items.Price_per_pack}}
                            </td>
                            <ng-template #hidePricePer>
                                <td><input type="text" [(ngModel)]="items.Price_per_pack" /></td>
                            </ng-template>
                        </tr>
                    </tbody>
                </table>
            </td>
            <td>
                <table class="table table-striped table-bordered text-center">
                    <thead>
                        <tr>
                            <th>RLD Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!combination_rld_Price; else rldPrice">
                            <td>{{rld_Price}}</td>
                        </tr>
                        <!-- To display RLD PRICE IN ARRAY -->
                        <ng-template #rldPrice>
                            <tr *ngFor="let items of combination_rld_Price; let i= index">
                                <td>{{items.RLD_Price | number:'3.1-5'}}</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </td>
            <td>{{rld_Amount}}</td>
            <td><button class="show-more-btn" (click)="showRLDCostData()" icon="pi pi-external-link" label="Show">
                    Show More
                </button></td>
        </tr>
        <tr>
            <td>BE Study Cost</td>
            <td *ngIf="!showBE; else hideBE" (click)="onClick()">{{BE_quantity}}</td>
            <ng-template #hideBE>
                <td><input type="text" [(ngModel)]="BE_quantity" /></td>
            </ng-template>
            <td *ngIf="!showBEPrice; else hideBEPrice" (click)="onClick()">$ {{BE_price}}</td>
            <ng-template #hideBEPrice>
                <td><input type="text" [(ngModel)]="BE_price" /></td>
            </ng-template>
            <td>$ {{BE_Total}}</td>
            <td><button class="show-more-btn" (click)="showBEStudyCostData()" icon="pi pi-external-link" label="Show">
                    Show More
                </button></td>
        </tr>
        <tr>
            <td>Development Cost</td>
            <td *ngIf="!showDevCost; else hideDev" (click)="onClick()">{{df_quantity}}</td>
            <ng-template #hideDev>
                <td><input type="text" [(ngModel)]="df_quantity" /></td>
            </ng-template>
            <td *ngIf="!showDevPrice; else hideDevPrice" (click)="onClick()">{{df_price}}</td>
            <ng-template #hideDevPrice>
                <td><input type="text" [(ngModel)]="df_price" /></td>
            </ng-template>
            <td>{{df_total}}</td>
            <td><button class="show-more-btn" (click)="showDevelopmentCostData()" icon="pi pi-external-link"
                    label="Show">
                    Show More
                </button></td>
        </tr>
        <tr>
            <td>IP Cost</td>
            <td *ngIf="!showIP; else hideIP" (click)="onClick()">{{ip_quantity}}</td>
            <ng-template #hideIP>
                <td><input type="text" [(ngModel)]="ip_quantity" /></td>
            </ng-template>
            <td *ngIf="!showIPPrice; else hideIPPrice" (click)="onClick()">{{ip_price}}</td>
            <ng-template #hideIPPrice>
                <td><input type="text" [(ngModel)]="ip_price" /></td>
            </ng-template>
            <td>{{ip_total}}</td>
            <td><button class="show-more-btn" (click)="showIpCostData()" icon="pi pi-external-link"
                    label="Show">
                    Show More
                </button></td>
        </tr>

        <tr>
            <td>Regulatory Cost</td>
            <td>1</td>
            <td>{{in_Data}}</td>
            <td>{{in_Data}}</td>
            <td></td>
        </tr>
        <tr>
            <td>CMO Cost</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td>Packaging Cost</td>
            <td *ngIf="!showPackage; else hideIP" (click)="onClick()">{{package_quantity}}</td>
            <ng-template #hideIP>
                <td><input type="text" [(ngModel)]="package_quantity" /></td>
            </ng-template>
            <td *ngIf="!showPackagePrice; else hideIPPrice" (click)="onClick()">{{package_price}}</td>
            <ng-template #hideIPPrice>
                <td><input type="text" [(ngModel)]="package_price" /></td>
            </ng-template>
            <td>{{package_total}}</td>
            <td></td>
        </tr>

        <tr class="mt-2">
            <td></td>
            <td></td>
            <td class="font-weight-bold">Grand Total</td>
            <td *ngIf="!total_Amount; else showAmount">{{ grandTotalCalculation() | currency}}</td>
            <ng-template #showAmount>
                <td>{{ total_Amount }}</td>
            </ng-template>
        </tr>
        </tbody>
        </table>
        <div>
            <button [disabled]="!disable" type="button" class="btn btn-primary" style="float: right;
        margin-right: 20px;" (click)="editAPICostDetails()">Save</button>
        </div>
    </div>
</div>

<p-dialog header="API Cost Details" [(visible)]="displayDialog" modal="modal" [style]="{width: '80vw'}"
    (onHide)="closeDialog()">
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of apiCostData | Object2keyvalue">
                <td *ngIf="item.key !== 'data' && item.key !== 'status'">{{ item.key }}
                </td>
                <td *ngIf="item.key !== 'data' && item.key !== 'status'">
                    <!-- Check if the value is an array -->
                    <ng-container *ngIf="item.value | arrayChk; else nonArray">
                        <!-- Check if the array contains objects -->
                        <ng-container *ngIf="item.value | tableChk; else listView">
                            <!-- Render array of objects as a table -->
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th *ngFor="let header of item.value[0] | Object2keyvalue">{{ header.key }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of item.value">
                                        <td *ngFor="let cell of row | Object2keyvalue">{{ cell.value || 'N/A' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                        <!-- Render simple arrays as a list -->
                        <ng-template #listView>
                            <ul>
                                <li *ngFor="let value of item.value">{{ value || 'N/A' }}</li>
                            </ul>
                        </ng-template>
                    </ng-container>
                    <!-- Handle non-array values directly -->
                    <ng-template #nonArray>
                        <p>{{ item.value || 'N/A' }}</p>
                    </ng-template>
                </td>
            </tr>
        </tbody>
    </table>
</p-dialog>

<p-dialog header="BE Study Cost Details" [(visible)]="displayBEDialog" modal="modal" [style]="{width: '80vw'}"
    (onHide)="closeBEDialog()">
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of BEStudyData | Object2keyvalue">
                <td *ngIf="item.key !== 'data' && item.key !== 'status'">{{ item.key }}</td>
                <td *ngIf="item.key !== 'data' && item.key !== 'status'">
                    <!-- Check if the value is an array -->
                    <ng-container *ngIf="item.value | arrayChk; else nonArray">
                        <!-- Check if the array contains objects -->
                        <ng-container *ngIf="item.value | tableChk; else listView">
                            <!-- Render array of objects as a table -->
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th *ngFor="let header of item.value[0] | Object2keyvalue">{{ header.key }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of item.value">
                                        <td *ngFor="let cell of row | Object2keyvalue">{{ cell.value || 'N/A' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                        <!-- Render simple arrays as a list -->
                        <ng-template #listView>
                            <ul>
                                <li *ngFor="let value of item.value">{{ value || 'N/A' }}</li>
                            </ul>
                        </ng-template>
                    </ng-container>
                    <!-- Handle non-array values directly -->
                    <ng-template #nonArray>
                        <p>{{ item.value || 'N/A' }}</p>
                    </ng-template>
                </td>
            </tr>
        </tbody>
    </table>
</p-dialog>

<p-dialog header="RLD Cost Details" [(visible)]="displayRldDialog" modal="modal" [style]="{width: '80vw'}"
    (onHide)="closeRldDialog()">
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of RLDCostData | Object2keyvalue">
                <td *ngIf="item.key !== 'RLDCost'">{{ item.key }}</td>
                <td *ngIf="item.key !== 'RLDCost'">
                    <!-- Check if the value is an array -->
                    <ng-container *ngIf="item.value | arrayChk; else nonArray">
                        <!-- Check if the array contains objects -->
                        <ng-container *ngIf="item.value | tableChk; else listView">
                            <!-- Render array of objects as a table -->
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th *ngFor="let header of item.value[0] | Object2keyvalue">{{ header.key }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of item.value">
                                        <td *ngFor="let cell of row | Object2keyvalue">{{ cell.value || 'N/A' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                        <!-- Render simple arrays as a list -->
                        <ng-template #listView>
                            <ul>
                                <li *ngFor="let value of item.value">{{ value || 'N/A' }}</li>
                            </ul>
                        </ng-template>
                    </ng-container>
                    <!-- Handle non-array values directly -->
                    <ng-template #nonArray>
                        <p>{{ item.value || 'N/A' }}</p>
                    </ng-template>
                </td>
            </tr>
        </tbody>
    </table>
</p-dialog>

<p-dialog header="Development Cost Details" [(visible)]="displayDevelopmentDialog" modal="modal"
    [style]="{width: '80vw'}" (onHide)="closeDevelopmentCostDialog()">
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of DEVLOPMENTCostData | Object2keyvalue">
                <td>{{ item.key }}</td>
                <td>{{ item.value || 'N/A' }}</td>
            </tr>
        </tbody>
    </table>
</p-dialog>

<p-dialog header="IP Cost Details" [(visible)]="displayIPDialog" modal="modal"
    [style]="{width: '80vw'}" (onHide)="closeIpCostDialog()">
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <th>Field</th>
                <th>Value</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of IPCostData | Object2keyvalue">
                <td>{{ item.key }}</td>
                <td>{{ item.value || 'N/A' }}</td>
            </tr>
        </tbody>
    </table>
</p-dialog>

<!--TIMELINE TABLE-->

<p-tabView>
    <p-tabPanel header="Timeline">
        <div class="card cost-api-card" style="padding: 2rem; margin-left: 1rem;">

            <!-- 2nd Table -->
            <div class="table-responsive">
                <table class="table table-striped table-bordered text-center">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Oral</th>
                            <th>Injectable</th>
                            <th>Topical</th>
                            <th>Others</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of tableData1">
                            <td>{{user.name}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data1"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy11"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data1}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data2"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy12"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data2}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data3"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy13"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data3}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data4"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy14"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data4}}</td>
                        </tr>

                        <!-- duplicating the code for PK End point row (start point) -->

                        <tr *ngFor="let user of tableData2">
                            <td>{{user.name}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data1"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy21"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data1}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data2"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy22"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data2}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data3"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy23"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data3}}</td>

                            <td *ngIf="user.id === editRowID"><input type="text" [(ngModel)]="user.data4"
                                    (keyup)="getVal($event.target.value)" [disabled]="timelineBEStudy24"></td>
                            <td *ngIf="user.id !== editRowID" (click)="edit(user.id)">{{user.data4}}</td>
                        </tr>

                        <!-- duplicating the code PK End point row (END point) -->


                    </tbody>
                </table>
                <div style="padding-bottom: 20px; padding-right: 20px;" class="text-right">
                    <button type="button" class="btn btn-primary" (click)="getTimelineDetails()">Submit</button>
                </div>

            </div>
            <!-- 2nd Table end -->

            <!-- 3rd new table -->

            <table class="table table-striped table-bordered text-center">
                <thead style="font-size: 16px;text-align: center;">
                    <tr>
                        <th *ngFor="let headers of newTimeline | tableHeaders" id="innertableheader">
                            <p>{{headers}}</p>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let trows of newTimeline | tableBody ;let m=index">
                        <td *ngFor="let rdata of trows;let iindex =index">
                            <p>{{rdata}} </p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </p-tabPanel>
</p-tabView>